import { render, staticRenderFns } from "./loadAdd.vue?vue&type=template&id=54bba9ab&"
import script from "./loadAdd.vue?vue&type=script&lang=js&"
export * from "./loadAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports